import ApiServer from '@/utils/api/ApiServer.js'
import { ALL_SETTING_KEY_STRINGS } from '@/utils/UserSettings.js'

export default {
  async getUserSettings (context) {
    const response = await ApiServer.get('userPreferences')
    if (response.status === 204) {
      return response.data
    }
    const newUserSettings = await handleInvalidUserSettings(context, JSON.parse(response.data.preferences))
    context.commit('setUserSettings', newUserSettings)
  },

  async updateUserSettings (context, userSettings) {
    if (JSON.stringify(context.getters.mutatedUserSettings) === JSON.stringify(context.getters.userSettings)) {
      return
    }

    const response = await ApiServer.post('userPreferences', {
      preferences: JSON.stringify(userSettings)
    })
    context.commit('setUserSettings', userSettings)
    return response.data
  },

  async deleteUserSetting (context, setting) {
    context.commit('removeUserSetting', setting)
    const getResponse = await ApiServer.get('userPreferences')
    const getResponseObj = JSON.parse(getResponse.data.preferences)
    delete getResponseObj[setting.type][setting.key]
    const postResponse = await ApiServer.post('userPreferences', {
      preferences: JSON.stringify(getResponseObj)
    })
    return postResponse.data
  }
}

const handleInvalidUserSettings = async (context, storedUserSettings) => {
  const defaultUserSettings = context.getters.mutatedUserSettings
  const updateWarrantedByIncompleteSettings = handleIncompleteUserSettings(storedUserSettings, defaultUserSettings)
  const updateWarrantedByOrphanedSettings = handleOrphanedUserSettings(storedUserSettings)

  if (updateWarrantedByIncompleteSettings || updateWarrantedByOrphanedSettings) {
    await ApiServer.post('userPreferences', {
      preferences: JSON.stringify(storedUserSettings)
    })
  }
  return storedUserSettings
}

function handleIncompleteUserSettings (storedUserSettings, defaultUserSettings) {
  let shouldUpdate = false
  // Delete any settings that have null or undefined keys
  Object.keys(storedUserSettings).forEach(type => {
    if (type === 'undefined' || type === 'null') {
      delete storedUserSettings[type]
      shouldUpdate = true
    } else {
      Object.keys(storedUserSettings[type]).forEach(key => {
        if (key === 'undefined' || key === 'null') {
          delete storedUserSettings[type][key]
          shouldUpdate = true
        }
      })
    }
  })

  Object.keys(defaultUserSettings).forEach(type => {
    if (!storedUserSettings[type]) {
      storedUserSettings[type] = defaultUserSettings[type]
      shouldUpdate = true
    } else {
      Object.keys(defaultUserSettings[type]).forEach(key => {
        if (!storedUserSettings[type][key]) {
          storedUserSettings[type][key] = defaultUserSettings[type][key]
          shouldUpdate = true
        }
      })
    }
  })
  return shouldUpdate
}

function handleOrphanedUserSettings (storedUserSettings) {
  let shouldUpdate = false
  // Delete settings for which there is no key in SETTING_KEYS
  Object.entries(storedUserSettings).forEach(([settingTypeName, settingTypeValues]) => {
    Object.keys(settingTypeValues).forEach((settingKey) => {
      if (!ALL_SETTING_KEY_STRINGS.includes(settingKey)) {
        delete storedUserSettings[settingTypeName][settingKey]
        console.warn(`Removed orphaned user preference: ${settingTypeName}.${settingKey}`)
        shouldUpdate = true
      }
    })
  })
  return shouldUpdate
}
